import React from "react";
import { ReturnOptions } from "../Components";

export const ReturnOptionsPage = () => {
  return <ReturnOptions />;
};
